import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { AppContext } from "../AppProvider";
import CBSGCharLoader from "../Page/CBSGCharLoader";

const AssignmentPage = () => {
  const { uri } = useContext(AppContext);
  const { id } = useParams();
  const [assignment, setAssignment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, offset: 10 });
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${uri}assignments/${id}/`)
      .then((response) => {
        setAssignment(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching assignment:", error);
        setError("Failed to load assignment.");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <CBSGCharLoader />;
  if (error || !assignment)
    return (
      <div className="text-center py-10 text-red-500 font-semibold text-lg">
        {error || "Assignment not found."}
      </div>
    );

  return (
    <div
      className="max-w-7xl mx-auto p-5 bg-white rounded-xl shadow-lg my-10"
      data-aos="fade-up"
    >
      <div className="flex flex-col lg:flex-row-reverse gap-6 items-center justify-center ">
        <div className="flex-shrink-0 w-full lg:w-1/2" data-aos="fade-right">
          {assignment.photo ? (
            <img
              src={assignment.photo}
              alt={assignment.title}
              className="w-full h-auto max-h-[24rem] object-cover rounded-lg shadow-lg"
            />
          ) : (
            <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center text-gray-500">
              No Image Available
            </div>
          )}
        </div>

        <div className="w-full lg:w-1/2 space-y-4" data-aos="fade-left">
          {assignment.company_logo && (
            <img
              src={assignment.company_logo}
              alt="Company Logo"
              className="h-16 object-contain mx-auto"
            />
          )}

          <h1 className="text-xl lg:text-2xl font-bold text-center lg:text-start text-gray-900">
            {assignment.title}
          </h1>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 text-sm sm:text-base text-gray-600">
            {/* Service Type */}
            <div className="bg-gray-100 px-4 py-2 rounded-lg shadow-sm">
              <strong className="block font-medium">Service Type:</strong>
              {assignment.service_type === "RE"
                ? "Research & Evaluation"
                : "Organization & Institutional Development"}
            </div>

            {/* Service Area */}
            <div className="bg-gray-100 px-4 py-2 rounded-lg shadow-sm">
              <strong className="block font-medium">Service Area:</strong>
              {assignment.sub_service_area?.name || "N/A"}
            </div>

            {/* Client */}
            <div className="bg-gray-100 px-4 py-2 rounded-lg shadow-sm">
              <strong className="block font-medium">Client:</strong>
              {assignment.select_client || "N/A"}
            </div>

            {/* Sectoral Presence (spans full width) */}
            <div className="lg:col-span-3 bg-gray-100 px-4 py-2 rounded-lg shadow-sm">
              <strong className="block font-medium">Sectoral Presence:</strong>
              {assignment.practice_areas?.map((area) => area.name).join(" || ") ||
                "N/A"}
            </div>
          </div>
        </div>
      </div>

      <div
        className="mt-8 text-gray-700 leading-relaxed text-justify dynamic-content"
        data-aos="fade-up"
        dangerouslySetInnerHTML={{ __html: assignment.description }}
      />
    </div>
  );
};

export default AssignmentPage;
